export default class HotelHighlightedServiceCard extends HTMLElement {
    
    constructor() {
        super();
        this.stylesheet = this.getAttribute('stylesheet');
        this.headerText = JSON.parse(this.getAttribute('header-text'));
        this.bodyText = this.getAttribute('body-text');
        this.icon = this.getAttribute('icon');
        this.url = this.getAttribute('url');
    }

    connectedCallback() {
        this._shadowRoot = this.attachShadow({mode: 'open'});
        const serviceHighlightedTemplate = document.querySelector('#hotel-highlighted-service-card-template');
        this.instance = serviceHighlightedTemplate.content.cloneNode(true);
        
        this.instance.querySelector('[name="stylesheet"]').href = this.stylesheet;
        this.instance.querySelector('[name="hotel-highlighted-service"]').classList.add('flex', 'text-h5');
        this.instance.querySelector('[name="hotel-highlighted-service-info"]').classList.add('ml-2');
        
        const serviceInfoHeader = this.instance.querySelector('[name="hotel-highlighted-service-card"]');
        this._fillServiceInfo(serviceInfoHeader);
        this._shadowRoot.appendChild(this.instance);
    }

    _fillServiceInfo(serviceInfoHeader) {
        serviceInfoHeader.classList.add('flex', 'mb-3');
        if (this.icon) {
            serviceInfoHeader.querySelector('i').classList.add(this.icon);
        }
        
        let serviceHeaderText = this.headerText;
        let serviceHeaderTextTemplate = this.instance.querySelector('[name="info-text"]');
        if (serviceHeaderText) {
            for(let text of serviceHeaderText){
                let textDiv = document.createElement("div");
                let textSplit = text.split(':');
                if (textSplit.length != 1) {
                    textSplit = "<b>" + textSplit.shift() + ": </b>" + textSplit.join(':');
                }
                textDiv.innerHTML = textSplit;
                serviceHeaderTextTemplate.appendChild(textDiv);
                serviceHeaderTextTemplate.appendChild(document.createElement("br"));
            }
        }

        let serviceBodyText = this.bodyText;
        if (serviceBodyText) {
            serviceBodyText = serviceBodyText.replace(
                '@@link_start@@', 
                "<a href='"+this.url+"' id='service-url' target='_blank'>"
            );
            serviceBodyText = serviceBodyText.replace('@@link_end@@', "</a>");
            this.instance.querySelector('[name="service-text"]').innerHTML = serviceBodyText;
        }
    }
}